import { render, staticRenderFns } from "./M2mC2.vue?vue&type=template&id=548c747e&scoped=true"
import script from "./M2mC2.vue?vue&type=script&lang=js"
export * from "./M2mC2.vue?vue&type=script&lang=js"
import style0 from "./M2mC2.vue?vue&type=style&index=0&id=548c747e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c747e",
  null
  
)

export default component.exports